// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListItemContainer-module__container--KJyXj{display:flex;position:relative;padding:20px 10px 20px 25px;border-bottom:1px solid #e5e6e6}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ListItemContainer-module__container--KJyXj`
};
export default ___CSS_LOADER_EXPORT___;
